export default "__VITE_ASSET__zhFXEMrK__"